import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from '../../style/LayoutComponents';
import { cssClass, Style } from '../../style/StyleFunctions';

const PREFIX = 'compose-email-dialog';
const DIALOG_WIDTH = 500;
const TEXT_AREA_HEIGHT = 200;

const MAXIMUM_BODY_LENGTH = 4000;
const MAXIMUM_SUBJECT_LENGTH = 78;

function TEST_ID(suffix: string) {
  return PREFIX + suffix;
}

const LabelTextDiv = divWithStyle(TEST_ID('label-text'), {
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  fontSize: TabStyles.Typography.Sizing.Default,
  color: TabStyles.Typography.Color.Primary,
});

const RecipientsDiv = divWithStyle(TEST_ID('recipients'), {
  paddingBottom: TabStyles.Spacing.MediumSpace,
});
const subjectStyle: React.CSSProperties & Style = { // resolve conflicting types, but FIXME better than this someday
  width: '100%'
};

const subjectContainer = cssClass('subjectContainerClass', {
  ...subjectStyle
});

const messageAreaStyle: React.CSSProperties = {
  height: TEXT_AREA_HEIGHT,
  resize: 'none'
};

const messageAreaClass = cssClass(TEST_ID('text-area'), {
  outline: 'none',
  boxSizing: 'border-box',
  width: '100%',
  overflow: 'auto',
  fontSize: TabStyles.Typography.Sizing.Default,
  marginBottom: TabStyles.Spacing.MediumSpace,
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace
});

const emailButtonStyle: React.CSSProperties = {
  marginLeft: TabStyles.Spacing.LargeSpace,
};

const buttonStyleSubmitting: React.CSSProperties = {
  verticalAlign: 'sub',
};

const dialogBodyStyle: React.CSSProperties = {
  paddingTop: TabStyles.Spacing.MediumSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

export const ComposeEmailDialogStyles = {
  PREFIX,
  DIALOG_WIDTH,
  TEXT_AREA_HEIGHT,
  MAXIMUM_BODY_LENGTH,
  MAXIMUM_SUBJECT_LENGTH,
  TEST_ID,
  LabelTextDiv,
  RecipientsDiv,
  subjectStyle,
  subjectContainer,
  messageAreaStyle,
  messageAreaClass,
  emailButtonStyle,
  buttonStyleSubmitting,
  dialogBodyStyle
}
